
    import '/home/ec2-user/Youlify-Design/docs/blog/form-names.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-blog-form-names-demo-zh-cn-0"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/home/ec2-user/Youlify-Design/docs/blog/form-names.zh-CN.md?type=demo')
};